export default __webpack_public_path__ + "static/media/dpd-fr.75c2f74f.svg";